

define(['angular', 'squid/index', './builder'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('tracking.fpti', ['squid', 'tracking.builder']).factory('$fpti', function ($config, $FptiBuilder, $rootScope, $window, $util) {

        var _beaconUrl;

        // Logic to switch between production/staging urls. This way we don't pollute live logs,
        // and we are able to test on stage using the fpti log viewing tool.
        if ($config.deploy.isLocal() || $config.deploy.isStage()) {
            _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
        } else {
            _beaconUrl = $config.urls && $config.urls.fptiBeaconUrl;
        }

        return {
            // Get all the tracking data defined at the page level
            getPageTrackingData: function getPageTrackingData(route) {
                route = route || {};

                var trackingData = route.trackingData || {};
                var routeParent = route.parent;

                trackingData.token = $rootScope.token;

                while (routeParent) {
                    trackingData = angular.merge({}, routeParent.trackingData || {}, trackingData);
                    routeParent = routeParent.parent;
                }
                return trackingData;
            },

            setupDataString: function setupDataString(route, err, data) {

                var trackingData = this.getPageTrackingData(route);
                var fptiData;

                var PAYPAL = window.PAYPAL;

                if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
                    PAYPAL.core = PAYPAL.core || {};

                    var payload = {
                        trackingData: trackingData,
                        error: err,
                        isInContext: $rootScope.miniBrowser
                    };

                    angular.extend(payload, data || {});

                    fptiData = new $FptiBuilder(payload).build().toString();

                    // FPTI client side tracking only if we have template
                    if (route && route.template && angular.isFunction(PAYPAL.analytics.setup)) {
                        PAYPAL.core.pta = PAYPAL.analytics.setup({
                            data: fptiData,
                            url: _beaconUrl
                        });
                    }
                }

                return fptiData;
            }
        };
    }).factory('$fptiError', function ($Error) {
        function stringifyErrorMessage(msg) {
            return encodeURIComponent(angular.isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
            : (angular.toJson(msg) || 'undefined').substring(0, 128));
        }

        return $Error.extend({
            construct: function construct(err) {
                if (!err) {
                    return;
                }
                this.type = err.type;
                this.field = err.field;
                this.msg = stringifyErrorMessage(err.message || err.error);
                this.code = err.code || err.cause;
            }
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-tracking/dist/fpti.js
// module id = ./components/xo-tracking/dist/fpti.js
// module chunks = 1